import React from 'react';
import './Brand.css';

function Brand({ light = false }) {
  return (
    <span className={`vanir-brand${light ? ' vanir-brand--light' : ''}`}>
      <svg className="vanir-brand__mark" viewBox="0 0 66 56" width="52" height="44" aria-hidden="true">
        <path d="M1 2h18l17 28-9 16z" fill="#00b9f2" /><path d="M26 2h17L34 17z" fill="#0077b6" /><path d="M47 2h18L35 54H17z" fill="#00a9e8" />
      </svg>
      <span className="vanir-brand__wordmark"><span>VANIR</span><span>MOTOR GROUP</span></span>
    </span>
  );
}

export default Brand;
